(ns app.front.view.profile.core
  (:require [app.domain.group.model :as group-model]
            [app.front.clipboard :as clipboard]
            [app.front.ui :as ui]
            [app.front.user :as front-user]
            [app.front.validate :as validate :refer [field-invalid-text
                                                     field-invalid?]]
            [app.front.view.profile.api-keys :as profile-api-keys]
            [app.front.view.profile.bluebeam :as profile-bluebeam]
            [app.front.view.profile.change-password :as change-password]
            [app.front.view.profile.email-notifications :as profile-notifications]
            [app.front.view.profile.licences :as profile-licences]
            [app.front.view.profile.mfa :as profile-mfa]
            [app.front.view.profile.oidc :as profile-oidc]
            [app.front.view.profile.subs :as profile-subs]
            [core.front.carbon :as cc]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [goog.functions]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))




(rf/reg-event-fx ::toggle-calendar-subscription-link
  (fn [_ [_ enabled?]]
    {:dispatch [:comm/command-monitored
                {:command    :user/set-calendar-subscription-link
                 :method     :post
                 :data       (util/mmap enabled?)
                 :on-success [::toggle-calendar-subscription.success]}]}))


(rf/reg-event-fx ::toggle-calendar-subscription.success
  (fn [_ [_ _ {:user/keys [calendar-subscription-key]}]]
    {:dispatch [::profile-subs/set-form-data [:user/calendar-subscription-key] calendar-subscription-key]}))


(defn ->international-telephone [path]
  (fn [v]
    (>evt [::profile-subs/set-form-data path v])))


(defn val->checked [path]
  (fn [checked] (>evt [::profile-subs/set-form-data path checked])))


(defn val->evt [path]
  (fn [e] (rf/dispatch-sync [::profile-subs/set-form-data path (-> e .-target .-value)])))


(defn calendar-subscription [tr]
  (let [subscription-key (<sub [::profile-subs/form-data [:user/calendar-subscription-key]])
        toggled?         (some? subscription-key)
        calendar-link    (when subscription-key
                           (str js/window.location.origin
                                "/api/command/user/calendar/"
                                subscription-key))]
    [:fieldset
     [:legend.mb-6.font-semibold.text-base (tr [:user/calendar-subscription-link])]
     [:div
      [:p (tr [:user/calendar-subscription-help])]
      [:p (tr [:user/calendar-subscription-events])]]
     [:div.flex.flex-wrap.items-center
      [:div.w-28
       (cc/toggle {:id         "toggle-calendar-subscription-link"
                   :disabled   (<sub [:comm/command-processing? :user/set-calendar-subscription-link])
                   :toggled    toggled?
                   :aria-label (tr [:user/calendar-subscription-link])
                   :class-name "unlabeled-toggle"
                   :on-toggle  #(>evt [::toggle-calendar-subscription-link (nil? subscription-key)])})]
      [:div.flex.flex-wrap.items-center
       (if calendar-link
         [:span.mr-1 calendar-link]
         [:span.italic (tr [:user/calendar-subscription-generate])])
       ;; Always keep copy button in dom to avoid bouncing text
       (cc/copy-button {:on-click   #(clipboard/copy-text calendar-link)
                        :class-name (if calendar-link "visible" "invisible")})]]]))

(defn bluebeam-section [tr]
  (let [{:keys [authentication-enabled? integration-enabled?]} (<sub [::profile-bluebeam/bluebeam-integration-data])
        processing?                                            (<sub [:comm/command-processing? :user/set-bluebeam-integration])
        auth-processing?                                       (<sub [:comm/command-processing? :user/set-bluebeam-authentication])
        current-user                                           (<sub [:session/user])
        config-flags                                           (-> current-user :user/config-flags set)
        prefers-browser?                                       (contains? config-flags :user.config-flag/prefers-bluebeam-browser?)
        prefers-desktop?                                       (contains? config-flags :user.config-flag/prefers-bluebeam-desktop?)
        has-preference?                                        (or prefers-browser? prefers-desktop?)
        clear-preference                                       #(do (>evt [::front-user/set-config-flag :user.config-flag/prefers-bluebeam-browser? false])
                                                                    (>evt [::front-user/set-config-flag :user.config-flag/prefers-bluebeam-desktop? false]))]
    [:fieldset
     [:legend.mb-6.font-semibold.text-base (tr [:profile/bluebeam-integration])]
     [:div.flex.flex-wrap.items-center
      [:div.w-28
       (cc/toggle {:id         "toggle-bluebeam-integration"
                   :disabled   processing?
                   :toggled    (true? integration-enabled?)
                   :aria-label (tr [:user/bluebeam-integration-on-message])
                   :class-name "unlabeled-toggle"
                   :on-toggle  #(>evt [::profile-bluebeam/toggle-bluebeam-integration (not integration-enabled?)])})]
      [:div.flex.flex-wrap.items-center
       [:span.italic (tr (if integration-enabled?
                           [:user/bluebeam-integration-off-message]
                           [:user/bluebeam-integration-on-message]))]]]
     [:div.mt-2
      (cc/button
        {:type     :submit
         :size     :field
         :disabled (or auth-processing? (not integration-enabled?))
         :on-click #(>evt [::profile-bluebeam/bluebeam-authentication])}
        (tr (if-not (and integration-enabled? authentication-enabled?)
              [:profile/bluebeam-integration-validate]
              [:profile/bluebeam-integration-validated])))]
     (when has-preference?
       [:div.mt-4
        (cc/button {:kind     :tertiary
                    :size     :field
                    :on-click clear-preference}
                   (tr [:profile/clear-bluebeam-session-preference]))])]))

(defn profile-form [tr]
  (r/with-let [validator       #(or (get (<sub [::profile-subs/server-errors]) %)
                                    (validate/validate-field %
                                                             (<sub [::profile-subs/form-data])
                                                             (<sub [::profile-subs/model])))
               initial-country (<sub [::front-config/country])
               authority-groups (<sub [:session/authority-groups])
               has-feature?     (fn [feature]
                                  (some #(group-model/has-feature? % feature) authority-groups))]
    [:section.flex.flex-col.w-full.gap-y-8
     [:div.flex.flex-col.w-full
      [:fieldset
       [:legend.mb-6.font-semibold.text-base (tr [:user/name-and-corporation])]
       [:div.flex.flex-wrap
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 required-input"}
         [cc/text-input {:id            "input-first-name"
                         :label-text    (tr [:user/first-name])
                         :light         true
                         :placeholder   (tr [:placeholder/first-name])
                         :default-value (<sub [::profile-subs/form-data [:user/first-name]])
                         :invalid       (field-invalid? validator :user/first-name)
                         :invalid-text  (field-invalid-text validator :user/first-name tr)
                         :on-change     (val->evt [:user/first-name])
                         :required      true}]]
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 required-input"}
         [cc/text-input {:id            "input-last-name"
                         :label-text    (tr [:user/last-name])
                         :light         true
                         :placeholder   (tr [:placeholder/last-name])
                         :default-value (<sub [::profile-subs/form-data [:user/last-name]])
                         :invalid       (field-invalid? validator :user/last-name)
                         :invalid-text  (field-invalid-text validator :user/last-name tr)
                         :on-change     (val->evt [:user/last-name])}]]]
       [:div.flex.mb-6.flex-wrap
        (cc/checkbox {:id         "choose-corporation-or-partnership"
                      :label-text (tr [:user/corporation-check-label])
                      :checked    (or (<sub [::profile-subs/corporation-checked]) false)
                      :on-change  (val->checked [:corporation-checked])})]
       [:div.mb-6.flex-wrap.collapsible {:class (str (if (<sub [::profile-subs/corporation-checked]) "flex" "hidden"))}
        [:div {:class "mb-6 w-full md:w-full lg:w-full xl:w-1/2 required-input"}
         [:div.mb-6 (tr [:user/signing-authority-note])]
         [cc/text-input {:id            "input-corporation-or-partnership"
                         :label-text    (tr [:user/corporation-or-partnership])
                         :light         true
                         :placeholder   (tr [:placeholder/company])
                         :default-value (<sub [::profile-subs/form-data [:user/corporation-or-partnership]])
                         :invalid       (field-invalid? validator :user/corporation-or-partnership)
                         :invalid-text  (field-invalid-text validator :user/corporation-or-partnership tr)
                         :on-change     (val->evt [:user/corporation-or-partnership])
                         :required      true}]]]]
      [:fieldset
       [:legend.mb-6.font-semibold.text-base (tr [:user/address])]
       [:div.flex.flex-wrap
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 required-input"}
         [cc/text-input {:id            "input-street-address"
                         :label-text    (tr [:user/street-address])
                         :light         true
                         :placeholder   (tr [:placeholder/street])
                         :default-value (<sub [::profile-subs/form-data [:user/street-address]])
                         :invalid       (field-invalid? validator :user/street-address)
                         :invalid-text  (field-invalid-text validator :user/street-address tr)
                         :on-change     (val->evt [:user/street-address])
                         :required      true}]]

        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4"}
         [cc/text-input {:id            "input-unit-number"
                         :label-text    (tr [:user/unit-number])
                         :light         true
                         :placeholder   (tr [:placeholder/unit])
                         :default-value (<sub [::profile-subs/form-data [:user/unit-number]])
                         :invalid       (field-invalid? validator :user/unit-number)
                         :invalid-text  (field-invalid-text validator :user/unit-number tr)
                         :on-change     (val->evt [:user/unit-number])}]]
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 mr-auto"}
         [cc/text-input {:id            "input-lot-con"
                         :label-text    (tr [:user/lot-con])
                         :light         true
                         :default-value (<sub [::profile-subs/form-data [:user/lot-con]])
                         :invalid       (field-invalid? validator :user/lot-con)
                         :invalid-text  (field-invalid-text validator :user/lot-con tr)
                         :on-change     (val->evt [:user/lot-con])}]]]
       [:div.flex.mb-6.flex-wrap
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 required-input"}
         [cc/text-input {:id            "input-municipality"
                         :label-text    (tr [:user/city])
                         :light         true
                         :placeholder   (tr [:placeholder/municipality])
                         :default-value (<sub [::profile-subs/form-data [:user/municipality]])
                         :invalid       (field-invalid? validator :user/municipality)
                         :invalid-text  (field-invalid-text validator :user/municipality tr)
                         :on-change     (val->evt [:user/municipality])
                         :required      true}]]
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 required-input"}
         [cc/text-input {:id            "input-province"
                         :label-text    (tr [:user/province])
                         :light         true
                         :placeholder   (tr [:placeholder/province])
                         :default-value (<sub [::profile-subs/form-data [:user/province]])
                         :invalid       (field-invalid? validator :user/province)
                         :invalid-text  (field-invalid-text validator :user/province tr)
                         :on-change     (val->evt [:user/province])
                         :required      true}]]
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 mr-auto required-input"}
         [cc/text-input {:id            "input-postal-code"
                         :label-text    (tr [:user/postal-code])
                         :light         true
                         :placeholder   (tr [:placeholder/postal-code])
                         :default-value (<sub [::profile-subs/form-data [:user/postal-code]])
                         :invalid       (field-invalid? validator :user/postal-code)
                         :invalid-text  (field-invalid-text validator :user/postal-code tr)
                         :on-change     (val->evt [:user/postal-code])
                         :required      true}]]]]
      [:fieldset
       [:legend.mb-6.font-semibold.text-base (tr [:user/phone-numbers])]
       [:div.flex.mb-6.flex-wrap
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 required-input"}
         [ui/intl-tel-input {:id              "input-mobile-phone"
                             :label-text      (tr [:user/mobile-phone])
                             :light           true
                             :placeholder     (tr [:placeholder/international-phone])
                             :value           (or (<sub [::profile-subs/form-data [:user/mobile-phone]]) "")
                             :invalid         (field-invalid? validator :user/mobile-phone)
                             :invalid-text    (field-invalid-text validator :user/mobile-phone tr)
                             :callback        (->international-telephone [:user/mobile-phone])
                             :required        true
                             :initial-country initial-country}]]
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4"}
         [ui/intl-tel-input {:id              "input-other-phone"
                             :label-text      (tr [:user/other-phone])
                             :light           true
                             :type            :phone
                             :placeholder     (tr [:placeholder/international-phone])
                             :value           (or (<sub [::profile-subs/form-data [:user/other-phone]]) "")
                             :invalid         (field-invalid? validator :user/other-phone)
                             :invalid-text    (field-invalid-text validator :user/other-phone tr)
                             :callback        (->international-telephone [:user/other-phone])
                             :initial-country initial-country}]]
        [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4 mr-auto"}
         [ui/intl-tel-input {:id              "input-fax"
                             :label-text      (tr [:user/fax])
                             :light           true
                             :type            :phone
                             :placeholder     (tr [:placeholder/international-phone])
                             :value           (or (<sub [::profile-subs/form-data [:user/fax]]) "")
                             :invalid         (field-invalid? validator :user/fax)
                             :invalid-text    (field-invalid-text validator :user/fax tr)
                             :callback        (->international-telephone [:user/fax])
                             :initial-country initial-country}]]]]
      [:fieldset
       [:legend.mb-6.font-semibold.text-base (tr [:user/email-address])]
       [:div.flex.flex-wrap
        [:div {:class "sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4"}
         [cc/text-input {:id            "input-email"
                         :label-text    (tr [:user/current-email-address])
                         :light         true
                         :type          :email
                         :default-value (<sub [::profile-subs/form-data [:user/email]])
                         :disabled      true}]]]]]
     [profile-notifications/email-toggles]
     [:fieldset
      [:legend.mb-6.font-semibold.text-base (tr [:user/professional-users])]
      [:div.flex.flex-wrap
       [:div {:class "pr-0 md:pr-4 w-full"}
        [cc/checkbox {:id         "choose-professional"
                      :label-text (tr [:user/i-am-professional])
                      :checked    (or (<sub [::profile-subs/form-data [:user/professional]]) false)
                      :on-change  #(>evt [::profile-subs/set-form-data [:user/professional] %])}]]]
      (when (<sub [::profile-subs/form-data [:user/professional]])
        [:<>
         [:div.flex.flex-wrap
          [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4"}
           [cc/text-input {:id            "input-company-name"
                           :label-text    (tr [:user/company-name])
                           :placeholder   (tr [:placeholder/company])
                           :light         true
                           :default-value (<sub [::profile-subs/form-data [:user/company-name]])
                           :on-change     (val->evt [:user/company-name])}]]
          [:div {:class "mb-6 sm:pr-0 md:pr-4 lg:pr-4 xl:pr-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4"}
           [cc/text-input {:id            "input-speciality-area"
                           :label-text    (tr [:user/specialty-area])
                           :placeholder   (tr [:placeholder/specialty-area])
                           :light         true
                           :default-value (<sub [::profile-subs/form-data [:user/speciality-area]])
                           :on-change     (val->evt [:user/speciality-area])}]]]
         [profile-licences/editor]])]
     (when (<sub [::ff/enabled? :feature-flag.id/calendar-subscription-link])
       [calendar-subscription tr])
     (if-let [oidc-name (<sub [::profile-subs/form-data [:oidc-config/display-name]])]
       [profile-oidc/current-oidc-provider tr oidc-name (<sub [::profile-subs/form-data [:user/email]])]
       [change-password/view])
     (when-let [oidc-suggestion (<sub [::profile-subs/oidc-suggestion])]
       [profile-oidc/connect-oidc-provider tr oidc-suggestion])
     (when-let [mfa-config (<sub [::profile-subs/form-data [:user/mfa-config]])]
       [profile-mfa/current-mfa-config tr mfa-config (<sub [::profile-subs/form-data [:db/id]])])
     (when-let [mfa-suggestions (seq (<sub [::profile-subs/mfa-suggestions]))]
       [profile-mfa/mfa-config-list tr mfa-suggestions])
     (when (has-feature? :group.feature/enable-bluebeam)
       [bluebeam-section tr])]))


(defn view [match]
  (let [tr       (<sub [:tr])
        pending? (<sub [::profile-subs/pending?])]
    [:div.cloudpermit-page
     [ui/page-header (util/mmap match)
      [:h1.my-8 (tr [:view/profile])]]
     (if pending?
       (cc/loading-spinner {:with-overlay false :small false})
       [:<>
        [profile-form tr]
        [profile-api-keys/section]])]))


(def profile-view
  {:name        :view/profile
   :view        view
   :breadcrumb  {:items [:view/profile]}
   :public?     false
   :controllers [{:start (fn [_]
                           (>evt [::profile-subs/init])
                           (>evt [::profile-oidc/init])
                           (>evt [::profile-subs/fetch-profile])
                           (>evt [::profile-api-keys/fetch-api-keys])
                           (>evt [::profile-bluebeam/fetch-integration-data]))}]})
